import { Box } from '@wix/design-system';
import { CoreDomainSearchStore, DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { harmonyStatusesOverrides } from '../HarmonySiteSearchGate';
import React, { useEffect } from 'react';
import { ResultsHeader } from '../../../Components/Headers/ResultsHeader/ResultsHeader';
import { Recommendations, RecommendationsError } from '../../../Components/Recommendations';
import { VoucherBanner } from '../../../Components/VoucherBanner';
import { HARMONY_FLOW_QUERY_PARAM } from '../../../constants';
import { useDomainSearchGateBi } from '../../../hooks/useDomainSearchGateBi';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { useQuerySubmit } from '../../../hooks/useQuerySubmit';
import { useRecommendations } from '../../../hooks/useRecommendations';
import { useResultsPageOfferingsBi } from '../../../hooks/useResultsPageOfferingsBi';
import { useViewTransition } from '../../../hooks/useViewTransition';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
import { GatePath } from '../../SiteLevelGate/SiteSearchGate';
import s from '../../harmonyResultsPage.scss';
import transition from '../../viewTransitions.css';
export const HarmonyDomainsResultsPage = _ref => {
  let {
    handlers,
    externalViewer,
    uiConfig
  } = _ref;
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      siteInfo: {
        externalViewer: Boolean(externalViewer)
      },
      handlers,
      uiConfig,
      statusesOverrides: harmonyStatusesOverrides
    }
  }, /*#__PURE__*/React.createElement(HarmonyDomainsResultsPageContent, {
    handlers: handlers,
    uiConfig: uiConfig
  }));
};
export const HarmonyDomainsResultsPageContent = _ref2 => {
  let {
    handlers,
    uiConfig
  } = _ref2;
  DomainSearchGateModule.SDK.hooks.useDomainsSearchGateBM();
  const isMobile = useIsMobile();
  const {
    navigateTo
  } = useViewTransition();
  useDomainSearchGateBi({
    viewMode: 'Gate Result Page'
  });
  const {
    recommendations,
    isLoading,
    query,
    hasNextPage: hasMore,
    fetchNextPage,
    isFetchingNextPage,
    error,
    biError,
    onRetry,
    isPricingLoading
  } = useRecommendations();
  const {
    updateUrl
  } = DomainSearchSuiteModule.SDK.hooks.useUrlRecovery();
  useQuerySubmit({});
  useResultsPageOfferingsBi({
    recommendations,
    isLoading,
    biError
  });
  useEffect(() => {
    // Reset store when component unmounts
    return () => {
      CoreDomainSearchStore.resetStore();
    };
  }, []);
  const emptyQueryStatus = !isLoading && recommendations.length > 0 && !query;
  const searchBar = /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.DomainSearchBar, {
    compact: true,
    showOptionsIfEmptyInput: false,
    autoFocus: false,
    useModalToolbar: isMobile,
    onSubmit: filters => {
      updateUrl(filters);
    },
    onFiltersChange: (key, value) => {
      if (key === 'tlds') {
        DomainSearchSuiteModule.internals.bi.onSelectTld == null || DomainSearchSuiteModule.internals.bi.onSelectTld({
          tld: JSON.stringify(value)
        });
      } else {
        DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
          ctaClick: key,
          value: JSON.stringify(value)
        });
      }
    },
    Layouts: {
      StatusComponent: () => emptyQueryStatus ? /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.EmptyQueryStatus, null) : /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.Status, null)
    }
  });
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      handlers,
      uiConfig,
      statusesOverrides: harmonyStatusesOverrides
    }
  }, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    display: "grid",
    className: `${s.resultsPage} ${s.noInsights}`,
    gap: "SP6 0",
    height: "100%",
    backgroundColor: "white",
    overflow: "auto"
  }, /*#__PURE__*/React.createElement(Box, {
    boxSizing: "border-box",
    align: "center",
    gridArea: "header",
    width: "100%",
    padding: "SP5 48px",
    backgroundColor: "white",
    direction: "vertical",
    gap: "SP6"
  }, /*#__PURE__*/React.createElement(VoucherBanner, null), /*#__PURE__*/React.createElement(ResultsHeader, {
    className: transition.header,
    onBackClick: () => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'back_button'
      });
      navigateTo(`${GatePath.GATE}?${HARMONY_FLOW_QUERY_PARAM}=true`);
      // To prevent seeing empty state before navigation
      setTimeout(() => {
        CoreDomainSearchStore.resetStore();
      });
    }
  })), /*#__PURE__*/React.createElement(Box, {
    gridArea: "searchbar",
    boxSizing: "border-box",
    position: "sticky",
    top: "0",
    zIndex: 10,
    backgroundColor: "white",
    padding: isMobile ? 'SP4 SP5 SP4 SP5' : 'SP4 48px SP4 48px',
    width: "100%",
    className: transition.searchBar
  }, searchBar), error ? /*#__PURE__*/React.createElement(RecommendationsError, {
    error: error,
    onRetry: onRetry,
    gridColumn: "1 / -1"
  }) : /*#__PURE__*/React.createElement(Recommendations, {
    recommendations: recommendations,
    isLoading: isLoading,
    hasMore: hasMore,
    isPricingLoading: isPricingLoading,
    fetchNextPage: () => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'show_more_results'
      });
      fetchNextPage();
    },
    isFetchingNextPage: isFetchingNextPage,
    gridArea: "content",
    className: s.centeredContent
  })));
};
//# sourceMappingURL=HarmonyDomainsResultsPage.js.map